"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Star25SVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var Star25SVG = function Star25SVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M28.28,11.46,21,10.12l-3.52-6.9C17.09,2.41,16.55,2,16,2s-1.09.41-1.51,1.22L11,10.12,3.72,11.46c-1.8.34-2.26,1.71-1,3.06l5.16,5.6-1,7.78c-.17,1.32.39,2.1,1.34,2.1a2.68,2.68,0,0,0,1.19-.33L16,26.3l6.65,3.37a2.68,2.68,0,0,0,1.19.33c.95,0,1.51-.78,1.34-2.1l-1-7.78,5.16-5.6C30.54,13.17,30.08,11.8,28.28,11.46Zm-6.26,8,1.1,8.21L16,24.05,8.88,27.66,10,19.45l2.34-7.55L16,4.69l3.69,7.21,7.93,1.48Z"
  }));
};
exports.Star25SVG = Star25SVG;
Star25SVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(Star25SVG);
exports.default = _default;